import React, { useState, lazy } from 'react';
import { ZapIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const MomentSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/mMRX3jvD7qp2qmnhYkA6sA/Generated_Image_October_28%2C_2025_-_12_24PM.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/rNFK5RbyNSRfcACAq7L7p3/Generated_Image_October_24%2C_2025_-_9_28AMb.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/suwYfPvS8CBUjX9SY96i2Z/Generated_Image_November_01%2C_2025_-_4_15PM.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/21a2jg3nGGRHtvHgGWLzxp/Generated_Image_October_28%2C_2025_-_12_24PM_%281%29.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ngM8eg34FdxiHbPJyvKDYV/Generated_Image_October_31%2C_2025_-_4_04PM.png'];
  const nextImage = () => {
    setCurrentImageIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  const prevImage = () => {
    setCurrentImageIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToImage = (index: number) => {
    setCurrentImageIndex(index);
  };
  return <section className="py-6 md:py-8 bg-bttf-bg text-bttf-text relative overflow-hidden" data-id="element-227">
      <div className="absolute inset-0 bg-bttf-highlight/20 mix-blend-overlay" data-id="element-228"></div>
      <div className="absolute -top-40 -left-40 w-80 h-80 bg-bttf-highlight/30 rounded-full blur-3xl" data-id="element-229"></div>
      <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-bttf-primary/20 rounded-full blur-3xl" data-id="element-230"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-231">
        <div className="text-center mb-6" data-id="element-232">
          <div className="flex justify-center mb-2" data-id="element-233">
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-234" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-235">
            The Moment That Changed Cinema Forever
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto" data-id="element-236"></div>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-237">
          <div className="flex justify-center mb-4" data-id="element-238">
            <ZapIcon className="h-16 w-16 text-bttf-accent shadow-neon-blue" data-id="element-239" />
          </div>
          <p className="text-xl text-center mb-3 text-bttf-text" data-id="element-240">
            When lightning struck the Hill Valley clock tower, it didn't just
            power a DeLorean.{' '}
            <span className="font-semibold text-bttf-accent" data-id="element-241">
              It powered a cultural phenomenon.
            </span>
          </p>
          <p className="text-lg mb-3 text-bttf-subtext" data-id="element-242">
            Director Robert Zemeckis and writer Bob Gale didn't just make a
            movie—they created a moment in history. From a young Michael J. Fox
            balancing two jobs, to Christopher Lloyd inventing Doc Brown's every
            twitch and grin, this is the story of how imagination conquered time
            itself.
          </p>
          <p className="text-lg text-bttf-subtext" data-id="element-243">
            And for the first time, it's all here—documented, curated, and told
            through emotion, detail, and legacy.
          </p>
        </div>
        {/* Image Carousel */}
        <div className="max-w-2xl mx-auto mt-8 relative" data-id="element-244">
          <div className="relative overflow-hidden rounded-lg" data-id="element-245">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentImageIndex * 100}%)`
          }} data-id="element-246">
              {images.map((image, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-247">
                  <div className="relative" data-id="element-248">
                    <div className="absolute -inset-1 bg-gradient-main rounded-lg blur-md opacity-50" data-id="element-249"></div>
                    <div className="relative w-full aspect-[4/3] rounded-lg shadow-2xl overflow-hidden" data-id="element-250">
                      <img src={image} alt={`Back to the Future 40th Anniversary Edition - Image ${index + 1}`} className="w-full h-full object-cover rounded-lg" loading="lazy" data-id="element-251" />
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Navigation Buttons */}
          <button onClick={prevImage} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text p-3 rounded-full shadow-neon-orange transition-all duration-300 hover:scale-110 z-10" aria-label="Previous image" data-id="element-252">
            <ChevronLeftIcon className="h-6 w-6" data-id="element-253" />
          </button>
          <button onClick={nextImage} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text p-3 rounded-full shadow-neon-orange transition-all duration-300 hover:scale-110 z-10" aria-label="Next image" data-id="element-254">
            <ChevronRightIcon className="h-6 w-6" data-id="element-255" />
          </button>
          {/* Dots Navigation */}
          <div className="flex justify-center gap-3 mt-8" data-id="element-256">
            {images.map((_, index) => <button key={index} onClick={() => goToImage(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentImageIndex ? 'bg-bttf-primary shadow-neon-orange w-8' : 'bg-bttf-subtext/50 hover:bg-bttf-subtext'}`} aria-label={`Go to image ${index + 1}`} data-id="element-257" />)}
          </div>
        </div>
      </div>
    </section>;
};
const StarIcon = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-258">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-259"></polygon>
  </svg>;